import { render, staticRenderFns } from "./PhysicGraph.vue?vue&type=template&id=5864dd55&"
import script from "./PhysicGraph.vue?vue&type=script&lang=js&"
export * from "./PhysicGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports